import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lns-app-layout',
  templateUrl: './app-layout.component.html'
})
export class AppLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
